<!-- eslint-disable -->
<template>
  <CommonPages id="privacy" :class="['privacy-page']" :titlePrefix="'Privacy Policy'"
    :metaDescription="domainConfig?.['meta']?.des || 'Privacy Policy and information about how we use your data'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Privacy Policy</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                Welcome to {{ domainConfig?.IAmURL }} (“we,” “our,” or “us”). Your privacy is
                important
                to us. This Privacy Policy explains how we collect, use, disclose, and safeguard
                your
                information when you visit our website and use our AI baby naming services.
                <br /><br />
                By using {{ domainConfig?.IAmURL }}, you agree to the practices described in this
                Privacy Policy.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. Information We Collect</h2>
              <h3 class="privacy-section__subtitle">a. Personal Information</h3>
              <p class="privacy-section__text">We may collect personal information that you
                voluntarily
                provide to us, such as:</p>
              <ul class="privacy-section__list">
                <li>Baby’s gender or name preferences</li>
                <li>Parent(s)’ names (if provided)</li>
                <li>Email address (if you subscribe to updates or contact us)</li>
                <li>Any custom inputs entered into our name generator tools</li>
              </ul>
              <h3 class="privacy-section__subtitle">b. Non-Personal Information</h3>
              <p class="privacy-section__text">When you use the site, we may automatically collect:
              </p>
              <ul class="privacy-section__list">
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device type</li>
                <li>Operating system</li>
                <li>Pages visited and time spent</li>
                <li>Referring URLs</li>
              </ul>
              <p class="privacy-section__text">This data helps us improve our services and user
                experience.</p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. How We Use Your Information</h2>
              <p class="privacy-section__text">We may use your information to:</p>
              <ul class="privacy-section__list">
                <li>Generate personalized baby names</li>
                <li>Improve our AI algorithms and naming recommendations</li>
                <li>Respond to your inquiries or requests</li>
                <li>Analyze site usage and trends</li>
                <li>Send occasional updates or newsletters (only if you opt-in)</li>
              </ul>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. Sharing of Information</h2>
              <p class="privacy-section__text">We do not sell, rent, or trade your personal
                information
                to third parties. We may share non-personal, aggregated data for analytics or
                marketing
                purposes.
                <br /><br />
                We may disclose information if:
              </p>
              <ul class="privacy-section__list">
                <li>Required by law or legal process</li>
                <li>Necessary to protect the rights or safety of users or the public</li>
                <li>In connection with a business transfer (e.g., merger or acquisition)</li>
              </ul>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. Use of Cookies</h2>
              <p class="privacy-section__text">
                We use cookies and similar technologies to enhance your experience, such as:
              </p>
              <ul class="privacy-section__list">
                <li>Remembering user preferences</li>
                <li>Tracking user behavior for analytics</li>
              </ul>
              <p class="privacy-section__text">
                You may disable cookies in your browser settings, but doing so may affect site
                functionality.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. Data Security</h2>
              <p class="privacy-section__text">
                We implement industry-standard security measures to protect your information.
                However,
                no method of data transmission or storage is completely secure, and we cannot
                guarantee
                absolute security.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">6. Children’s Privacy</h2>
              <p class="privacy-section__text">
                Our website is designed for parents and guardians. We do not knowingly collect
                personal
                information from children under 13. If we discover that we have inadvertently
                collected
                such data, we will promptly delete it.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">7. Third-Party Links</h2>
              <p class="privacy-section__text">
                Our site may contain links to third-party websites. We are not responsible for their
                content or privacy practices. Please review their privacy policies before providing
                them
                with your information.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">8. Your Choices and Rights</h2>
              <p class="privacy-section__text">You may:</p>
              <ul class="privacy-section__list">
                <li>Request access to or correction of your personal data</li>
                <li>Opt out of receiving marketing communications</li>
                <li>Request that we delete your data (where applicable)</li>
              </ul>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">9. Changes to This Policy</h2>
              <p class="privacy-section__text">
                We may update this Privacy Policy from time to time. Your continued use of our
                website
                after any update constitutes your acceptance of the updated policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Privacy',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Privacy] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	// margin: 0 0 rem(88);
	padding-bottom: rem(88);
	background: #191919;

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(180);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #fff;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #fff;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #fff;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #fff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #fff;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #fff;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #fff;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #fff;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 